import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';
import { styled } from 'linaria/react';
import { Colorways } from '@uds/colorway';

interface RootProps {
  last: boolean | undefined;
}

export const StyledRoot = styled.div<RootProps>`
  &,
  > div {
    height: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  overflow: hidden;
  margin-bottom: ${(props) => (props.last === true ? 0 : 'inherit')};
`;

const content = css`
  background-color: transparent;

  &,
  > div {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
`;

const body = css`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const ctas = css`
  overflow: hidden;
  margin-top: ${cssTheme.gu2};
`;

const cta = {
  default: css`
    margin-top: ${cssTheme.gu1};
  `,
  spaceCtas: css`
    ${cssTheme.breakpoints.sm} {
      margin-right: ${cssTheme.gu1};
      display: inline-block;
    }
  `,
};

const greyBackground = css`
  background: ${cssTheme.palette.grey12};
`;

const whiteBackground = css`
  background: #fff;
`;

const transparentBackground = css`
  background: transparent;
`;

interface Props {
  hasMultipleCtas: boolean;
  colorway: Colorways;
}

export default ({ hasMultipleCtas, colorway }: Props) => {
  return {
    content: cx(content, colorway === Colorways.LIGHT ? greyBackground : whiteBackground),
    body,
    ctas,
    cta: cx(cta.default, hasMultipleCtas === true && cta.spaceCtas),
    panel: transparentBackground,
  };
};
